module.exports = __webpack_public_path__ + "static/media/stories-2.b84c0cf8.png";